/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import ReservationEvent from '../../event/ReservationEvent'
import { MonthlyReservationsState } from '../state/ReservationState'

class MonthlyReservationsStore extends ReduceStore<State, Action> {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new MonthlyReservationsState()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case ReservationEvent.fetchMonthlyByDate:
        return state.merge({
          date: payload.date,
          reservations: payload.reservations,
          event_schedules: payload.event_schedules
        })

      default:
        return state
    }
  }
}

export default new MonthlyReservationsStore()
